const messages = {
  title: "Listini prezzi e brochure PRODOTTO",
  title_media: "Listini prezzi e brochure PRODOTTO",
  description:
    "Scarica qui le ultime brochure e i volantini sui nostri pneumatici Bridgestone e Firestone per auto, SUV e veicoli commerciali.",
  short_description:
    "Qui trovi contenuti per i social media, l'in-store TV e altro.",
  mediaCategories: {
    products: "Prodotti",
    brand_and_solutions: "Marca e soluzioni",
    season_and_promotions: "Stagione e promozioni",
    format: "Formato",
    cars_and_vans: "Auto, SUV, veicoli commerciali",
    truck_and_buses: "Camion e autobus",
    motorcycle: "Moto",
    agriculture: "Agricoltura",
    construction_machinery: "Macchine edili",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiali",
    brochures: "Brochure prodotto",
    price_list: "Listini prezzi",
    materials: "Materiali",
    video_in_store: "Video con sottotitoli",
    video_online: "Video senza sottotitoli",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Social media",
    logos: "Logos",
    summer: "Estivi",
    winter: "Invernali",
    all_season: "Quattro stagioni",
    promotions: "Promozioni",
    price: "Pricat",
  },
  buttons: {
    media: "SCOPRI",
  },
  searchMedia: "Inserisci una parola chiave",
  searchResults: "Risultati della ricerca",
};

export default {
  messages,
};
